import * as S from "./styles";

const Stepper = ({ step }) => {
  return (
    <S.Wrapper>
      <S.Step active={step >= 0} />
      <S.Step active={step >= 1} />
    </S.Wrapper>
  );
};

export default Stepper;
